import { useState, useEffect } from 'react';
export function useCountdown(expiresAt) {
    const [remaining, setRemaining] = useState('');
    const [isUrgent, setIsUrgent] = useState(false);
    useEffect(() => {
        if (!expiresAt)
            return;
        const update = () => {
            const diff = new Date(expiresAt).getTime() - Date.now();
            if (diff <= 0) {
                setRemaining('00:00');
                setIsUrgent(true);
                return;
            }
            const hours = Math.floor(diff / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            setRemaining(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`);
            setIsUrgent(diff < 6 * 3600000); // < 6 hours
        };
        update();
        const interval = setInterval(update, 60000);
        return () => clearInterval(interval);
    }, [expiresAt]);
    return { remaining, isUrgent };
}
